var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('subMap',{ref:"subMap",attrs:{"layer-name":_vm.layerName,"layer-code":_vm.layerCode}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }